import { MdOutlineFileDownload } from "react-icons/md";
import { COLORS } from "shared/style/colors";

const Item = ({ name, size, onDownload }) => {
  const fileNameWithoutExtension = name.replace(/\.[^/.]+$/, "");
  return (
    <div className="documentDownloadLmf__item">
      <div className="documentDownloadLmf__item--details">
        <span className="--name">{fileNameWithoutExtension}</span>
        <span className="--size">.pdf {size && <>| size</>}</span>
      </div>
      <span className="documentDownloadLmf__item--action" onClick={onDownload}>
        <MdOutlineFileDownload size={20} color={COLORS.C_WHITE} />
      </span>
    </div>
  );
};
export default Item;
